export const storage = {
  set(key: string, value: string): void {
    try {
      if (typeof window !== 'undefined') {
        window.localStorage && window.localStorage.setItem(key, value)
      }
    } catch (error) {
      if (error instanceof DOMException && error.name === 'QuotaExceededError') {
        this.clear()
        alert('Local data storage was cleared to keep things working. Please, login again.')
      } else {
        throw error
      }
    }
  },
  get(key: string): string | null {
    if (typeof window !== 'undefined') {
      return window.localStorage && window.localStorage.getItem(key)
    }
    return null
  },
  clear(): void {
    if (typeof window !== 'undefined') {
      window.localStorage && window.localStorage.clear()
    }
  },
  remove(key: string): void {
    if (typeof window !== 'undefined') {
      window.localStorage && window.localStorage.removeItem(key)
    }
  },
}

export default storage
